/**
 * Lista DDT (Fase 2.2). Filtro emesso/ricevuto. UI solo da @floraltech/ui.
 */
import { Button, Card, CardContent } from '@floraltech/ui';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUrlState } from '@lib/useUrlState';

interface DDTRiga {
  id: string;
  numero: string;
  direzione: string;
  stato: string;
  data_ddt: string;
  controparte_denominazione: string | null;
  importo_totale: number | string;
}

const fmtEUR = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' });

export function DDTList() {
  const navigate = useNavigate();
  const [ddt, setDdt] = useState<DDTRiga[]>([]);
  const [direzione, setDirezione] = useUrlState('direzione', 'emesso');

  useEffect(() => {
    void (async () => {
      const res = await fetch(`/api/v1/ddt?direzione=${direzione}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token') ?? ''}` },
      });
      if (res.ok) setDdt(await res.json());
      else setDdt([]);
    })();
  }, [direzione]);

  return (
    <div className="space-y-6 p-6">
      <div className="flex items-center justify-between">
        <h1 className="font-outfit text-2xl font-semibold">Documenti di trasporto</h1>
        <Button size="sm" onClick={() => navigate('/ddt/nuovo')}>
          Nuovo DDT
        </Button>
      </div>

      <div className="flex gap-2">
        {['emesso', 'ricevuto'].map((d) => (
          <button
            key={d}
            className={
              'rounded px-3 py-1 text-sm ' +
              (direzione === d
                ? 'bg-neutral-800 text-white dark:bg-neutral-200 dark:text-neutral-900'
                : 'bg-neutral-100 text-neutral-700 dark:bg-neutral-800 dark:text-neutral-300')
            }
            onClick={() => setDirezione(d)}
          >
            {d === 'emesso' ? 'Emessi (a cliente)' : 'Ricevuti (da fornitore)'}
          </button>
        ))}
      </div>

      <Card>
        <CardContent className="pt-6">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-muted-foreground">
                <th className="pb-2">Numero</th>
                <th className="pb-2">Data</th>
                <th className="pb-2">{direzione === 'emesso' ? 'Cliente' : 'Fornitore'}</th>
                <th className="pb-2">Stato</th>
                <th className="pb-2">Totale</th>
              </tr>
            </thead>
            <tbody>
              {ddt.map((d) => (
                <tr
                  key={d.id}
                  className="cursor-pointer border-t hover:bg-neutral-50 dark:hover:bg-neutral-800"
                  onClick={() => navigate(`/ddt/${d.id}`)}
                >
                  <td className="py-2">{d.numero}</td>
                  <td className="py-2">{d.data_ddt}</td>
                  <td className="py-2">{d.controparte_denominazione ?? '-'}</td>
                  <td className="py-2">{d.stato}</td>
                  <td className="py-2">{fmtEUR.format(Number(d.importo_totale))}</td>
                </tr>
              ))}
              {ddt.length === 0 && (
                <tr>
                  <td colSpan={5} className="py-4 text-center text-muted-foreground">
                    Nessun DDT {direzione}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </CardContent>
      </Card>
    </div>
  );
}

export default DDTList;
